import React from 'react';
import MatchTable from '../Common/MatchTable';
import { Remark } from '../Common/MatchBase';

const HAD = () => {
    
    return (
        <section className='HAD'>
            <MatchTable betType='HAD' etBetType='EHA' />
            <Remark />
        </section>
    )
}
export default HAD;